class Header {
  constructor() {
    this._init();
  }

  _init() {
    const header = document.querySelector('header');
    if (!header) return;

    window.addEventListener('scroll', () => {
      if (window.scrollY > 20) {
        header?.classList.add('scrolled');
      } else {
        header?.classList.remove('scrolled');
      }
    });

    const burger = document.querySelector('.header__burger');
    const menu = document.querySelector('.header__menu');

    burger?.addEventListener('click', () => {
      burger.classList.toggle('active');
      menu?.classList.toggle('active');
      header?.classList.toggle('active');
    });

    const contactBtn = document.querySelector('.js-scroll-contact');
    contactBtn?.addEventListener('click', () => {
      const contactTarget = document.querySelector('#contact');
      if (contactTarget) {
        const headerHeight = (header as HTMLElement).offsetHeight;
        const targetPosition = contactTarget.getBoundingClientRect().top + window.scrollY - headerHeight;

        burger?.classList.remove('active');
        menu?.classList.remove('active');
        header?.classList.remove('active');

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth',
        });
      }
    });
  }
}

export const header = new Header();
